import { Provider } from '@angular/core';
import {
  MODULE_ROUTE_CONTRIBUTIONS,
  ModuleRouteContribution,
  registerModuleRoutePrefixes,
} from '@models/routing/module-route-contribution';

/**
 * Registra las rutas del módulo "Tareas" (TaskFlow) en el mecanismo dinámico del shell
 * (`DynamicModuleHostComponent`, colgado del wildcard '**' bajo AppLayoutComponent),
 * en lugar de declararlas en `app.routes.ts`.
 *
 * Único costo real para agregar este módulo al arranque: UNA línea en el array
 * `providers` de `app.config.ts` (`provideTasksRoutes()`). Ni `app.routes.ts` ni
 * los JSON centrales de i18n necesitan tocarse para las rutas/textos propios del módulo.
 *
 * Nota de matching: '/tareas' y '/tareas/reportes' comparten prefijo. El host resuelve
 * esto eligiendo, entre las contribuciones cuyo `urlPrefix` matchea la URL actual, la del
 * `urlPrefix` MÁS LARGO — por eso no hace falta ordenar este array ni usar `matches`
 * custom aquí; basta con declarar ambos `urlPrefix` tal cual.
 */
export function provideTasksRoutes(): Provider {
  const contributions: ModuleRouteContribution[] = [
    {
      urlPrefix: '/tareas',
      loadComponent: () => import('./tareas/tareas.component').then(m => m.TareasComponent),
      title: 'titles.tareas',
    },
    {
      urlPrefix: '/tareas/reportes',
      loadComponent: () => import('./reportes/task-reportes.component').then(m => m.TaskReportesComponent),
      title: 'titles.reportesTareas',
    },
  ];

  // Registro plano (no-DI), leído por el `UrlMatcher` del wildcard en app.routes.ts — ver
  // `registerModuleRoutePrefixes` para por qué esto es necesario además del provider de abajo.
  registerModuleRoutePrefixes(contributions);

  return {
    provide: MODULE_ROUTE_CONTRIBUTIONS,
    multi: true,
    useValue: contributions,
  };
}
